import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiTag = class PiTag extends Vue {
    removeClick() {
        this.$emit("on-close");
    }
    tagClick() {
        this.$emit("on-click");
    }
};
__decorate([
    Prop({ default: "default" })
], PiTag.prototype, "color", void 0);
__decorate([
    Prop({ default: "" })
], PiTag.prototype, "type", void 0);
__decorate([
    Prop({ default: false })
], PiTag.prototype, "closable", void 0);
PiTag = __decorate([
    Component
], PiTag);
export default PiTag;
